import Button from '@components/actions/button';
import Typography from '@components/basics/typography';
import AppState from '@webapp/store/state';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';

export interface subscriptionProps {
  className?: string;
  clientId: string;
  subscriptionId: string;
  isMobile: boolean;
  goToPlans: (props: any) => CallHistoryMethodAction;
  continueToRelease: any;
}
const mapStateToProps = (state: AppState) => ({
  clientId: state.artist.active?.id || '',
  subscriptionId: state.subscription.current?.id || '',
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToPlans: (props: any) =>
    dispatch(push(`/plans/${props.clientId}/${props.subscriptionId}`)),
});
const BottomFixedUpgrade = (props: subscriptionProps) => {
  return (
    <StickyBottom>
      {props.isMobile ? (
        <FooterRow>
          <RowItemHeader>
            <Typography className="bold">
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_1.TOTAL" />
            </Typography>
          </RowItemHeader>
          <RowItem>
            <Typography className="bold">
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_1.FREE" />
            </Typography>
          </RowItem>
          <RowItem className="row-3">
            <Typography className="title">
              <b>$5.00</b>/m
            </Typography>
            <Typography className="subtitle">
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_1.BILLED" />
            </Typography>
          </RowItem>
        </FooterRow>
      ) : null}
      <ButtonContainer>
        <Button
          className="dark-button"
          buttonType="secondary"
          onClick={props.continueToRelease}
        >
          <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_2.CONTINUE" />
        </Button>

        <Button
          buttonType="primary"
          className={props.className}
          onClick={() =>
            props.goToPlans({
              clientId: props.clientId,
              subscriptionId: props.subscriptionId,
            })
          }
        >
          <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_2.UPGRADE" />
        </Button>
      </ButtonContainer>
    </StickyBottom>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(BottomFixedUpgrade);

const StickyBottom = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  z-index: 999;
  background: ${({ theme }) => theme.colors.inputBackground};
  .dark-button {
    background: ${({ theme }) =>
      theme.colors.inputBackgroundAlternateDark} !important;
    span {
      color: ${({ theme }) => theme.colors.primary} !important;
    }
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-bottom: 30px;
  padding-top: 30px;
  gap: 1.5rem;
  padding-right: 0rem;
  @media ${({ theme }) => theme.device.mobileL} {
    padding-right: 2rem;
  }
`;
const FooterRow = styled.div`
  display: flex;
  padding-top: 0.5rem;
`;
const RowItem = styled.div`
  width: 30%;
  @media ${({ theme }) => theme.device.mobileL} {
    width: 25%;
  }
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  .title {
    font-size: ${({ theme }) => theme.typography.h4};
    font-weight: 400;
    display: block;
  }
  .subTitle {
    font-size: 1 ${({ theme }) => theme.typography.h4};
    font-weight: 400;
    display: block;
    opacity: 0.6;
  }
  .bold {
    font-weight: 700;
  }
  .row-3 {
    .title {
      font-weight: 400;
    }
    .subTitle {
      font-size: ${({ theme }) => theme.typography.span};
    }
  }
`;
const RowItemHeader = styled.div`
  width: 40%;
  @media ${({ theme }) => theme.device.mobileL} {
    width: 50%;
  }
  font-size: ${({ theme }) => theme.typography.h3};
  font-weight: 600;
  margin-top: auto;
  margin-bottom: auto;
  .subtitle {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.typography.span};
    font-weight: 400;
    opacity: 0.5;
    display: block;
  }
  .bold {
    font-weight: 700;
  }
`;
